export default __webpack_public_path__ + "static/media/logo.09964050.svg";